import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Link from "@material-ui/core/Link";

import { useStyles } from "./DashboardLibrary.css";
import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";

class DashboardLibrary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        { name: "Book Name" },
        { name: "Available Copies" },
        { name: "Author" },
      ],
      bookList: [],
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
            <Paper className={classes.body}>
              <div>Library Books</div>
              <TableContainer>
                <Table>
                  <CustomTableHead column={this.state.column} />
                  <TableBody>
                    {this.props.bookList.slice(0, 4).map((book, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">{book.title}</TableCell>
                        <TableCell align="center">
                          {book.currentStock}
                        </TableCell>
                        <TableCell align="center">{book.author}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Link href="/administration/library" style={{ marginTop: 10 }}>
                See More Books
              </Link>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(DashboardLibrary));
